import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { LoginProvider } from '../login/login';

@Injectable()
export class SettingsProvider {

  ismURL = environment.ismUrl;

  constructor(public http: HttpClient, private storage :Storage, private loginProvider: LoginProvider, private translate: TranslateService) {}

  // setLanguage(lang: string){
  //   this.translate.use(lang.match(/en|zh|vi|km|/) ? lang : 'en');
  // }
  
  getLanguage(){
    let lang = localStorage.getItem('lang');
    if(!lang){
      lang = this.translate.getBrowserLang();
    }
    return lang ? lang : 'en';
  }

  getLanguages(){
    console.log("getLanguagae performed" )
    let langs = Object.keys(environment.languages)
    if(!langs) langs = ['en'];
    return langs;
  }
  initializeLanguage(){
    console.log("initaize perfoemd")
    return this.setLanguage(null);
  }
  setLanguage(lang: string){
    console.log("setLanguage performed");
    if(!lang){
      lang = localStorage.getItem('lang');
    }
    if(!lang){
      lang = this.translate.getBrowserLang();
    }
    lang = lang.match(environment.langPattern) ? lang : 'en';                
    localStorage.setItem('lang', lang);
    if(environment.debug) console.log("locale set =>: ", lang);
    this.translate.use(lang.match(/en|zh|vi|km|/) ? lang : 'en');
    console.log(lang)
    return lang;
  }
  getNotificationStatus(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(this.ismURL,`/getNotificationSound`,val))
        .toPromise();
      }
    });
  }

  updateUserInfo(userInfo){
    return this.getToken().then((val) => {
      if(val){
        return this.http.put<Response>(this.getUrl(this.ismURL,`/updateUser`,val), userInfo)
        .toPromise().then(value => {
        
          return this.storage.get("loginDetails").then((val) => {
            if(val){
              this.loginProvider.updateUserRegisterApp(val);
              return value;
            }
        });
      });
      }
    });
  }

  setNotificationStatus(type: string, _switch: boolean){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(this.ismURL,`/setNotificationSound`,val), {
          type,
          switch: (_switch)? 1: 0,
        })
        .toPromise();
      }
    });
  }

  getUserDetails(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<any>(this.getUrl(this.ismURL,`/userDetail`,val))
        .toPromise();
      }
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(url:string, link: string, val: any):string {
    return `${url}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}




// WEBPACK FOOTER //
// ./src/providers/settings/settings.ts